import { render, staticRenderFns } from "./NewBusinessParticulars.vue?vue&type=template&id=595cf50a&scoped=true&"
import script from "./NewBusinessParticulars.vue?vue&type=script&lang=js&"
export * from "./NewBusinessParticulars.vue?vue&type=script&lang=js&"
import style0 from "./NewBusinessParticulars.vue?vue&type=style&index=0&id=595cf50a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595cf50a",
  null
  
)

export default component.exports